export const instrumentationBoostrapTypes = {
    TeamPage: "TeamPage",
    LandingPage: "LandingPage"
};
